var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                staticStyle: {
                  "min-width": "160px",
                  width: "100%",
                  height: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "10px" }
                },
                [
                  _c("div", { staticClass: "filters" }),
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "cargo-button-group-slider",
                        [
                          _c("c-a-btn-group", {
                            staticStyle: { "flex-wrap": "wrap" },
                            attrs: {
                              "source-view": "detail",
                              job: _vm.job,
                              hp: _vm.cADetailHp,
                              "active-tab-name": _vm.activeTabName
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { "white-space": "nowrap" } }, [
                        _c(
                          "label",
                          {
                            staticClass: "red",
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "15px",
                              height: "25px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.jobState))]
                        ),
                        _c(
                          "label",
                          {
                            staticClass: "red",
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "15px",
                              height: "25px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.jobChangeState))]
                        ),
                        _c("label", [_vm._v(_vm._s(""))]),
                        _c(
                          "label",
                          {
                            staticClass: "blue",
                            staticStyle: { height: "25px" }
                          },
                          [_vm._v(_vm._s(_vm.job.jobNo))]
                        ),
                        _c(
                          "label",
                          {
                            staticClass: "blue",
                            staticStyle: { height: "25px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$store.getters.language === "zh"
                                  ? _vm.customerChineseName
                                  : _vm.customerEnglishName
                              )
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: 10,
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Basic"),
                            name: "basic"
                          }
                        },
                        [
                          _c("basic", {
                            ref: "basic",
                            attrs: {
                              lob: _vm.lob,
                              "master-flag": _vm.masterFlag,
                              "se-context": _vm.seContext,
                              job: _vm.job
                            }
                          })
                        ],
                        1
                      ),
                      _vm.lob === "SE"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 20,
                              attrs: {
                                lazy: true,
                                name: "tabVesselEq",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _c("tab-vessel-eq", {
                                ref: "tabVesselEq",
                                attrs: {
                                  context: _vm.seContext,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 21,
                          attrs: {
                            lazy: true,
                            name: "tabCharges",
                            label: _vm.$t("CargoMsg.Cargo_Cost")
                          }
                        },
                        [
                          _c("tab-charges", {
                            ref: "tabCharges",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              adjust: _vm.adjust,
                              location: _vm.location,
                              "is-from-finance": ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 22,
                          attrs: {
                            lazy: true,
                            name: "tabInternalBill",
                            label: _vm.$t("CargoMsg.Cargo_DomesticBill")
                          }
                        },
                        [
                          _c("tab-internal-bill", {
                            ref: "tabInternalBill",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              location: _vm.location
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 23,
                          attrs: {
                            lazy: true,
                            name: "tabOverseaBill",
                            label: _vm.$t("CargoMsg.Cargo_InternationalBill")
                          }
                        },
                        [
                          _c("tab-oversea-bill", {
                            ref: "tabOverseaBill",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              location: _vm.location
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 24,
                          attrs: {
                            lazy: true,
                            name: "tabAdvanceCharge",
                            label: _vm.$t("CargoMsg.Cargo_AdvanceChargeInfo")
                          }
                        },
                        [
                          _c("tab-advance-charge", {
                            ref: "tabAdvanceCharge",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              adjust: _vm.adjust,
                              location: _vm.location
                            }
                          })
                        ],
                        1
                      ),
                      _vm.showTabSopState
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 29,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("CargoMsg.Cargo_BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.seContext,
                                  action: _vm.action,
                                  "is-from-finance": ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 28,
                          attrs: {
                            lazy: true,
                            name: "tabFileHistory",
                            label: _vm.$t("CargoMsg.Cargo_FileHistory")
                          }
                        },
                        [
                          _c("tab-file-history", {
                            ref: "tabFileHistory",
                            attrs: { context: _vm.seContext }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }